import * as React from "react";
import { observer } from "mobx-react";
import { InputBoolean } from "../Shared";
import { IInputBooleanComponentStatus } from "../States/AreaUiInfo";

export interface IInputBooleanComponentProps {
	model: InputBoolean;
	onChange?: () => void;
	uiContext?: IInputBooleanComponentStatus;
	testId?: string;
}

@observer
export class InputBooleanComponent extends React.Component<IInputBooleanComponentProps, {}> {

	handleChange = (event: React.FormEvent<any>) => {
		this.props.model.value = (event.target as any).checked as boolean;
		if (this.props.onChange) {
			this.props.onChange();
		}
		if (this.props.uiContext) {
			this.props.uiContext.inputBooleanComponentStatus.set(this.props.model.label, this.props.model.value);
		}
	}

	componentDidMount() {
		if (this.props.uiContext && this.props.uiContext.inputBooleanComponentStatus.has(this.props.model.label)) {
			this.props.model.value = this.props.uiContext.inputBooleanComponentStatus.get(this.props.model.label);
		}
	}

	render() {
		let label = this.props.model.label ? <span data-test-id={this.props.testId + "Label"}>{this.props.model.label}</span> : null;;

		return <label className="custom-radiocheck" data-test-id={this.props.testId}>
			<input
				type="checkbox"
				checked={this.props.model.value}
				onChange={this.handleChange}
				disabled={this.props.model.isReadOnly}
				className={!this.props.model.isValid ? "is--input-invalid" : null} />
			<span className="checkbox-style" title={this.props.model.tooltip}></span>
			{label}
			{this.props.model.validationMessage ? <span className="is--validation-note">{this.props.model.validationMessage}</span> : null}
		</label>;
	}
}

